import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { PaginasGuard } from './data/services/guards/paginas.guard'
import { LoginGuard } from './data/services/guards/login.guard'

const routes: Routes = [
  {path:"", redirectTo:"/splash", pathMatch:"full"},
  {
    path: '',
    loadChildren: () => import('./components/footer/footer.module').then(m => m.FooterPageModule),canActivate:[LoginGuard]
  },
  {
    path: 'modal',
    loadChildren: () => import('./components/modal/modal.module').then( m => m.ModalPageModule) ,canActivate:[LoginGuard]
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule), canActivate:[PaginasGuard]
  },
  {
    path: 'vender',
    loadChildren: () => import('./components/vender/vender.module').then( m => m.VenderPageModule) ,canActivate:[LoginGuard]
  },
  {
    path: 'infoservices/:idServicio',
    loadChildren: () => import('./pages/information/infoservices/infoservices.module').then( m => m.InfoservicesPageModule) ,canActivate:[LoginGuard]
  },
  {
    path: 'search',
    loadChildren: () => import('./components/search/search.module').then( m => m.SearchPageModule) ,canActivate:[LoginGuard]
  },
  {
    path: 'specials',
    loadChildren: () => import('./components/specials/specials.module').then( m => m.SpecialsPageModule) ,canActivate:[LoginGuard]
  },
  {
    path: 'promo',
    loadChildren: () => import('./components/promo/promo.module').then( m => m.PromoPageModule) ,canActivate:[LoginGuard]
  },
  {
    path: 'splash',
    loadChildren: () => import('./components/splash/splash.module').then( m => m.SplashPageModule)
  },
  {
    path: 'renovaciones-promos',
    loadChildren: () => import('./components/renovaciones-promos/renovaciones-promos.module').then( m => m.RenovacionesPromosPageModule)
  },
  {
    path: 'history-referrals',
    loadChildren: () => import('./pages/history-referrals/history-referrals.module').then( m => m.HistoryReferralsPageModule)
  },
  {
    path: 'modal-awards',
    loadChildren: () => import('./components/modal-awards/modal-awards.module').then( m => m.ModalAwardsPageModule)
  },
  {
    path: 'recordatorio',
    loadChildren: () => import('./components/recordatorio/recordatorio.module').then( m => m.RecordatorioPageModule)
  },  {
    path: 'games',
    loadChildren: () => import('./pages/games/games.module').then( m => m.GamesPageModule)
  }


];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
